export function filterApps(list) {
    let ignoreFiles = ['index-new.html','config.json','qr-config.json','index2.html','static','footer.html','header.html','favicon.ico','sz.png','zzt.png','zt_assistant.jpg','ydy.png','ydd.png','ztbh.png','kdcs.png','kdgjxcx.jpg','ztkj.png','zxt.png','reminder.jpeg','account.jpg'];
    return list.filter(item=>ignoreFiles.indexOf(item.name)==-1);
}